type Props = {
  rate: number;
};
export const AttendanceRate = ({ rate }: Props) => {
  return <>{Math.round(rate * 100)}%</>;
};
